import { useEffect, useRef } from 'react';

import type { CodeString } from '@/consts/codes';
import type { MenuItem } from '@/consts/navigation';
import { useLocation } from 'react-router';

export const useTrackRecents = (
  addRecent: (code: CodeString | undefined) => Promise<void>,
  allMenuItems: MenuItem[]
) => {
  const location = useLocation();
  const lastCodeRef = useRef<string | null>(null);

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    const currentItem = allMenuItems.find((item) => item.to === currentPath || item.to === location.pathname);

    if (!currentItem?.code) return;

    if (lastCodeRef.current === currentItem.code) return;
    lastCodeRef.current = currentItem.code;

    void addRecent(currentItem.code);
  }, [location.pathname, location.search, addRecent, allMenuItems]);
};
